import React, { Component, ReactNode } from 'react';
import { Link } from 'react-router-dom';

class ProfileComponentItem extends Component<Props> {
  render() {
    const { onClick, label, href, secondLabel, icon } = this.props;
    return (
      <Link
        onClick={onClick}
        key={label}
        className={`flex gap-x-3 px-3 border-b-[0.5px] items-center justify-start min-w-[180px] py-3 hover:bg-[#F9FAFB] cursor-pointer`}
        data-testid={'profile_component_logout'}
        to={href}
      >
        <div className={'flex items-center justify-center'}>{icon}</div>
        <div className={'flex flex-col w-full'}>
          <p className={'text-lg text-f-black-2'}>{label}</p>
          <p className={'text-3xs text-[#607080]'}>{secondLabel ?? secondLabel}</p>
        </div>
      </Link>
    );
  }
}

interface Props {
  icon: ReactNode;
  label: string;
  href: string;
  secondLabel?: string;
  onClick: (event: any) => void;
}

export default ProfileComponentItem;
